import { InjectionToken, ValueProvider } from '@angular/core';

export const SESSION_API_ORIGIN = new InjectionToken<string>('Session API Origin');
export const provideSessionApiOrigin = (origin: string): ValueProvider => ({
  provide: SESSION_API_ORIGIN,
  useValue: origin,
});
